import React from "react";
import { useTheme } from "../ThemeProvider";
import "./embed.css";
import Header from "../components/header/mainHeader.js";
import Footer from "../components/footer/mainFooter.js";
import SingleUsecaseCall from "../singleUsecase/singleUsecaseCall/singleUsecaseCall.js";
import SingleUsecaseHero from "../singleUsecase/singleUsecaseHero/singleUsecaseHero.js";
import SingleUsecaseDescription from "../singleUsecase/singleUsecaseDescription/singleUsecaseDescription.js";
import SingleUsecasePhoto from "../singleUsecase/singleUsecasePhoto/singleUsecasePhoto.js";

import a from "../assets/fitness/01.webp";
import b from "../assets/fitness/02.webp";
import c from "../assets/fitness/03.webp";
import d from "../assets/fitness/04.webp";
import e from "../assets/fitness/05.webp";

function FitnessFlex() {
  const { theme } = useTheme();

  document.title = "3VO | Fitness Flex";

  return (
    <div className={`subpage ${theme === "light" ? "" : "dark-theme"}`}>
      <Header />
      <SingleUsecaseHero title="Fitness Flex" subtitle="" />
      <SingleUsecasePhoto img={a} name="Fitness Flex" />
      <SingleUsecasePhoto img={b} name="Fitness Flex" />
      <SingleUsecasePhoto img={c} name="Fitness Flex" />
      <SingleUsecasePhoto img={d} name="Fitness Flex" />
      <SingleUsecasePhoto img={e} name="Fitness Flex" />
      <SingleUsecaseCall />
      <Footer />
    </div>
  );
}

export default FitnessFlex;
